import { InputDialog, InputOptions } from "src/components/Modalservice/InputDialog";
import { useDialog } from "src/components/Modalservice/Dialogservice";
import React from "react";
import { useI18n } from "src/utils/lni18n";


export const useInput = () => {
    const dialogPortal = useDialog();
    const { languageService: t } = useI18n();

    function input(title: string, message: string | React.ReactNode, text?: string) {

        return dialogPortal({
            factory: (onSubmit, onCancel) => {
                const dprops: InputOptions = {
                    title: title,
                    message: message,
                    languageService: t,
                    onCancel: onCancel,
                    onSubmit: onSubmit,
                    type: "input",
                    text: text
                }
                return <InputDialog {...dprops} />
            },
            size: "md"
        });
        
    }

    return input;

}